export default {
	name: 'safety-management',
	path: '/safety-management',
	redirect: '/safety-management/dangerous-zone',
	meta: {
		title: '安全管理',
		icon: 'icon-safety-management'
	},
	children: [
		{
			name: 'dangerous-zone',
			path: 'dangerous-zone',
			fullPath: '/safety-management/dangerous-zone',
			meta: {
				title: '危险区域预警系统',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "safety-management" */ '@/views/safety-management/dangerous-zone')
		},
		{
			name: 'dangerous-add',
			path: 'dangerous-add',
			fullPath: '/safety-management/dangerous-add',
			meta: {
				title: '添加危险区域'
			},
			component: () =>
				import(/* webpackChunkName: "safety-management" */ '@/views/safety-management/dangerous-zone/add')
		},
		{
			name: 'dangerous-edit',
			path: 'dangerous-edit',
			fullPath: '/safety-management/dangerous-edit',
			meta: {
				title: '修改危险区域'
			},
			component: () =>
				import(/* webpackChunkName: "safety-management" */ '@/views/safety-management/dangerous-zone/add')
		},
		{
			name: 'black-system',
			path: 'black-system',
			redirect: '/safety-management/black-system/list',
			fullPath: '/safety-management/black-system',
			meta: {
				title: '黑名单预警系统'
			},
			component: () =>
				import(/* webpackChunkName: "safety-management" */ '@/views/safety-management/black-system'),
			children: [
				{
					name: 'black-list',
					path: 'list',
					fullPath: '/safety-management/black-system/list',
					meta: {
						title: '学校黑名单库'
					},
					component: () =>
						import(/* webpackChunkName: "safety-management" */ '@/views/safety-management/black-system/list')
				},
				{
					name: 'black-import',
					path: 'import',
					fullPath: '/safety-management/black-system/list/import',
					meta: {
						title: '导入黑名单库'
					},
					component: () =>
						import(/* webpackChunkName: "safety-management" */ '@/views/safety-management/black-system/list/listImport')
				},
				{
					name: 'black-record',
					path: 'record',
					fullPath: '/safety-management/black-system/record',
					meta: {
						title: '预警记录'
					},
					component: () =>
						import(/* webpackChunkName: "safety-management" */ '@/views/safety-management/black-system/record')
				},
				{
					name: 'black-edit',
					path: 'edit',
					fullPath: '/safety-management/black-system/edit',
					meta: {
						title: '预警布控'
					},
					component: () =>
						import(/* webpackChunkName: "safety-management" */ '@/views/safety-management/black-system/edit')
				}
			]
		},
		{
			name: 'school-video',
			path: 'school-video',
			fullPath: '/safety-management/school-video',
			meta: {
				title: '校园直播',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "safety-management" */ '@/views/safety-management/school-video')
		},
		{
			name: 'get-flow',
			path: 'get-flow',
			fullPath: '/safety-management/get-flow',
			meta: {
				title: '设置取流方式'
			},
			component: () =>
				import(/* webpackChunkName: "safety-management" */ '@/views/safety-management/school-video/flow')
		},
		{
			name: 'addCamera',
			path: 'addCamera',
			fullPath: '/safety-management/camera',
			meta: {
				title: '添加摄像头'
			},
			component: () => import('@/views/safety-management/school-video/camera')
		},
		{
			name: 'pushFlowTest',
			path: 'pushFlowTest',
			fullPath: '/safety-management/pushFlowTest',
			meta: {
				// title: '推流测试'
			},
			component: () =>
				import('@/views/safety-management/school-video/pushFlowTest')
		},
		{
			name: 'videoParameters',
			path: 'videoParameters',
			fullPath: '/safety-management/videoParameters',
			meta: {
				// title: '视频参数查询'
			},
			component: () =>
				import('@/views/safety-management/school-video/videoParameters')
		}
	]
};
